import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import { ErrorBoundary, RootErrorFallback } from "@/components/tpr/ErrorBoundary";
import { initializeSentry } from "@/core/sentry";

import "./styles/tpr.css";

// Initialize Sentry before rendering
initializeSentry();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ErrorBoundary level="root" fallback={RootErrorFallback}>
      <App />
    </ErrorBoundary>
  </StrictMode>
);
